import { MenuEntry } from '@src/menu-entry';

export default [
    MenuEntry.create()
        .setRoute('incoming_goods_overview')
        .setAdditionalRoutes([
            'incoming_goods_show',
        ]),
    MenuEntry.create()
        .setRoute('incoming_goods_avise'),
    MenuEntry.create()
        .setRoute('incoming_goods_damaged_products'),
    MenuEntry.create()
        .setRoute('incoming_goods_subsequent_serial'),
    MenuEntry.create()
        .setRoute('voucher_stock_entry'),
    MenuEntry.create()
        .setRoute('voucher_stock_entry_config'),
];
